import { c as _c } from "react/compiler-runtime";
import { ESTABLISHMENT_CITY, ESTABLISHMENT_NAME, HIDE_IMAGE_IN_BOOKING_SUMMARY } from '@/constants/config';
const BookingDetailHeader = t0 => {
    const $ = _c(16);
    const { entity, contentClassName: t1 } = t0;
    const contentClassName = t1 === undefined ? "" : t1;
    let t2;
    if ($[0] !== entity.medias) {
        t2 = !HIDE_IMAGE_IN_BOOKING_SUMMARY && entity.medias.media[0]?.url ? {
            backgroundImage: `url(${entity.medias.media[0].url})`
        } : null;
        $[0] = entity.medias;
        $[1] = t2;
    }
    else {
        t2 = $[1];
    }
    const bannerImgStyle = t2;
    const entityType = entity.typeActivity.name;
    const computedContentClassName = `py-4 px-6 font-semibold ${contentClassName}`;
    const entityLocation = `${ESTABLISHMENT_NAME}, ${ESTABLISHMENT_CITY}`;
    let t3;
    if ($[2] !== bannerImgStyle) {
        t3 = bannerImgStyle ? <div className="relative inset-0 h-36 xxs:h-48 bg-cover bg-center bg-no-repeat overflow-hidden rounded lg:!rounded-b-none" style={bannerImgStyle}><div className="gradient absolute left-0 opacity-20 w-1/6 h-full bg-gradient-to-r from-black via-transparent to-transparent"/><div className="gradient absolute right-0 opacity-20 w-1/6 h-full bg-gradient-to-l from-black via-transparent to-transparent"/></div> : null;
        $[2] = bannerImgStyle;
        $[3] = t3;
    }
    else {
        t3 = $[3];
    }
    let t4;
    if ($[4] !== entity.name) {
        t4 = <h4 className="text-lg mr-10 pb-0">{entity.name}</h4>;
        $[4] = entity.name;
        $[5] = t4;
    }
    else {
        t4 = $[5];
    }
    let t5;
    if ($[6] !== entityType) {
        t5 = <p className="text-xs uppercase">{entityType}</p>;
        $[6] = entityType;
        $[7] = t5;
    }
    else {
        t5 = $[7];
    }
    let t6;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = <p className="text-sm text-gray-500">{entityLocation}</p>;
        $[8] = t6;
    }
    else {
        t6 = $[8];
    }
    let t7;
    if ($[9] !== computedContentClassName || $[10] !== t4 || $[11] !== t5) {
        t7 = <div className={computedContentClassName}>{t4}{t5}{t6}</div>;
        $[9] = computedContentClassName;
        $[10] = t4;
        $[11] = t5;
        $[12] = t7;
    }
    else {
        t7 = $[12];
    }
    let t8;
    if ($[13] !== t3 || $[14] !== t7) {
        t8 = <div className="relative flex-shrink-0 box-border">{t3}{t7}</div>;
        $[13] = t3;
        $[14] = t7;
        $[15] = t8;
    }
    else {
        t8 = $[15];
    }
    return t8;
};
export default BookingDetailHeader;
